import {
  CellStyleModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  ColumnApiModule,
  DateEditorModule,
  DateFilterModule,
  GridStateModule,
  LocaleModule,
  ModuleRegistry,
  NumberEditorModule,
  NumberFilterModule,
  PinnedRowModule,
  RowApiModule,
  RowSelectionModule,
  RowStyleModule,
  TextEditorModule,
  TextFilterModule,
  ValidationModule,
} from "ag-grid-community";
import {
  // Core enterprise features
  CellSelectionModule,
  ClipboardModule,
  ColumnsToolPanelModule,
  ContextMenuModule,

  // Filtering and grouping
  FiltersToolPanelModule,
  RowGroupingModule,
  SetFilterModule,

  // Advanced features
  IntegratedChartsModule,
  RichSelectModule,
  SideBarModule,

  // Row features
  LicenseManager,
  ExcelExportModule,
  MasterDetailModule,
} from "ag-grid-enterprise";
import { AgChartsCommunityModule } from "ag-charts-community";

let isAGGridSetup = false;

export function setupAGGrid() {
  if (isAGGridSetup) return;

  // Set up the license
  LicenseManager.setLicenseKey(
    "Using_this_{AG_Grid}_Enterprise_key_{AG-075628}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Imoova}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Imoova}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Imoova}_need_to_be_licensed___{Imoova}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{24_January_2026}____[v3]_[01]_MTc2OTIxMjgwMDAwMA==db68ea6eb69c4620bd47c76e4217d225",
  );

  // Register only the specific modules we actually use
  ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    ClientSideRowModelApiModule,
    ValidationModule,
    RowSelectionModule,
    PinnedRowModule,
    RowStyleModule,
    DateFilterModule,
    TextFilterModule,
    NumberFilterModule,
    CellStyleModule,
    DateEditorModule,
    TextEditorModule,
    NumberEditorModule,
    RowApiModule,
    GridStateModule,
    ColumnApiModule,
    LocaleModule,

    // Core enterprise features
    CellSelectionModule,
    ClipboardModule,
    ColumnsToolPanelModule,
    ContextMenuModule,

    // Filtering and grouping
    FiltersToolPanelModule,
    RowGroupingModule,
    SetFilterModule,

    // Advanced features
    IntegratedChartsModule.with(AgChartsCommunityModule),
    RichSelectModule,
    SideBarModule,
    ExcelExportModule,

    MasterDetailModule,
  ]);

  isAGGridSetup = true;
}
